export default __webpack_public_path__ + "static/media/physioImage.df8f8471.png";